import { ExternalLink, FileSearch } from "lucide-react";

function confClass(c) {
  if (c >= 0.8) return "bg-emerald-950/60 text-emerald-300 border-emerald-800/60";
  if (c >= 0.6) return "bg-amber-950/60 text-amber-300 border-amber-800/60";
  return "bg-rose-950/60 text-rose-300 border-rose-800/60";
}

export function EvidenceBadge({ evidence }) {
  const url = evidence.source_url || "";
  const isExternal = url.startsWith("http");
  // Confidence can be 0-1 (mock) or 0-100 (Airtable "Confidence Percent" — but sample shows values 0-1 too, keep tolerant).
  const conf = evidence.confidence;
  const pct = conf > 1 ? conf : Math.round((conf || 0) * 100);
  const confBand = pct >= 80 ? "bg-emerald-950/60 text-emerald-300 border-emerald-800/60"
                   : pct >= 60 ? "bg-amber-950/60 text-amber-300 border-amber-800/60"
                   : "bg-rose-950/60 text-rose-300 border-rose-800/60";
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-[11px] font-mono border ${confBand}`}
      data-testid={`evidence-badge-${evidence.id}`}
      title={evidence._source === "airtable" ? `AIRTABLE · ${evidence.airtable_record_id}${evidence.verified ? ' · verified' : ''}${evidence.reviewer ? ' · reviewer: ' + evidence.reviewer : ''}` : "MOCK"}
    >
      <FileSearch size={11} />
      <span className="max-w-[340px] truncate">{evidence.snippet || "(no observation)"}</span>
      <span className="opacity-70">{pct}%</span>
      {evidence._source === "airtable" && (
        <span className="opacity-70 border-l border-current/30 pl-1.5 ml-0.5">AT</span>
      )}
      {isExternal && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`evidence-link-${evidence.id}`}
          className="hover:opacity-80"
          onClick={(e) => e.stopPropagation()}
        >
          <ExternalLink size={11} />
        </a>
      )}
    </div>
  );
}

export function EvidenceList({ evidence, emptyText = "No evidence attached" }) {
  if (!evidence?.length) {
    return <div className="font-mono text-xs text-rose-400/80" data-testid="evidence-empty">{emptyText}</div>;
  }
  return (
    <div className="flex flex-col gap-1.5" data-testid="evidence-list">
      {evidence.map((e) => (
        <EvidenceBadge key={e.id} evidence={e} />
      ))}
    </div>
  );
}
